// packages/utils/src/shared/dates/formatDateToLocal.ts

// Browser-native localized short-date formatter (year/month-short/day).
// Uses `Intl.DateTimeFormat` so it works offline without DB-backed
// translation keys — pass any BCP-47 language tag (e.g. "en", "sv", "es").
export function formatDateToLocal(date: Date, langCode: string): string {
	const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
	return new Intl.DateTimeFormat(langCode, options).format(date);
}
